import { createContext, useContext, type FC, type ReactNode } from 'react'
import { type ReCaptchaStore } from '../store/reCaptchaStore'

export const ReCaptchaContext = createContext<ReCaptchaStore | null>(null)

export const useReCaptchaContext = () => {
  const context = useContext(ReCaptchaContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with ReCaptchaContext')

  return context
}

type IProviderReCaptchaProps = {
  value: ReCaptchaStore
  children: ReactNode
}

export const ProviderReCaptcha: FC<IProviderReCaptchaProps> = ({ value, children }) => {
  return <ReCaptchaContext.Provider value={value}>{children}</ReCaptchaContext.Provider>
}
